/**
 * Module definition for all common implementations.
 *
 * @module stack.common
 */
angular.module('stack.common.api.models', [
  'stack.common.api.models.ModelsService',
  'stack.common.api.models.CrudService'
]);
